import React, { useState, useEffect } from "react";
import { doc, setDoc, deleteDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { RiShoppingCartLine } from "react-icons/ri";
import Cookies from "js-cookie";
import { MdAdd, MdRemove } from "react-icons/md";

function getGuestId() {
  let guestId = localStorage.getItem("guestId");
  if (!guestId) {
    guestId = "guest_" + Math.random().toString(36).substring(2, 12);
    localStorage.setItem("guestId", guestId);
  }
  return guestId;
}

export default function Add_cart({ product }) {
  const [qty, setQty] = useState(0);
  const [guestId, setGuestId] = useState(getGuestId());
  const productuid = typeof product === "string" ? product : product?.uid;

  useEffect(() => {
    const sessionToken = Cookies.get("sessiontoken");
    const guid = Cookies.get("guid");
    if (sessionToken && guid) {
      setGuestId(guid);
    }
  }, []);

  useEffect(() => {
    if (!productuid || !guestId) return;
    const fetchQty = async () => {
      try {
        const ref = doc(db, "cart_items", guestId, "items", productuid);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          setQty(data.qty || 1);
        } else {
          setQty(0);
        }
      } catch (err) {
        console.error("Error fetching qty:", err);
      }
    };
    fetchQty();
  }, [productuid, guestId]);

  const updateQty = async (newQty) => {
    if (!productuid || !guestId) return;
    const ref = doc(db, "cart_items", guestId, "items", productuid);

    try {
      if (newQty <= 0) {
        await deleteDoc(ref);
        setQty(0);
      } else {
        await setDoc(ref, {
          uid: productuid,
          productuid,
          qty: newQty,
          createdAt: new Date(),
        });
        setQty(newQty);
      }
    } catch (err) {
      console.error("Error updating qty:", err);
    }
  };

  return (
    <div>
      {qty > 0 ? (
        <div className="button-ui2 flex green-back items-center gap-5">
          <div
            onClick={() => updateQty(qty - 1)}
            className=" cursor"
            title="Decrease quantity"
          >
           <MdRemove className="icon" />
          </div>
          <div className=" m-lr flex items-center gap-1 ">
            <RiShoppingCartLine className="icon" /><div className="m-left">{qty}</div>
          </div>
          <div
            onClick={() => updateQty(qty + 1)}
            className=""
            title="Increase quantity"
          >
            <MdAdd className="icon" />
          </div>
        </div>
      ) : (
        <div
          onClick={() => updateQty(1)}
          title="Add to Cart"
          className="button-ui2 fill cursor"
        >
          <RiShoppingCartLine className="icon" /> +
        </div>
      )}
    </div>
  );
}
